import { PropsWithChildren } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();

  const token = localStorage.getItem("id_token");

  if (!token) {
    return <Navigate to={`/login?final_redirect_uri=${encodeURIComponent(location.pathname)}`} replace={true} />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
